import React, { Fragment } from 'react';

class SelectedUserInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { selectedUser } = this.props;

        if (!selectedUser) {
            return null;
        } else {
            return (<div className="paper-block" style={{fontSize: '12px'}}>
                    <span className="name-block absolute">Selected user</span>

                    <div> Name - {selectedUser.name ? selectedUser.name : ''} </div>
                    <div> Email - {selectedUser.email ? selectedUser.email : ''}  </div>
                </div>
            )
        }
    }
}

export default SelectedUserInfo;



// WEBPACK FOOTER //
// ./app/components/Users/BlackAndWhiteLists/SelectedUserInfo.jsx